angular.module("UndergroundWebApp").directive("statisticsDonutChart", [
    "$location",
    function ($location) {
        return {
            restrict: "E",
            scope: {
                locations: "=",
                totallocations: "=",
                header: "=",
                noeventstext: "=",
            },
            template: `
<div class="statistics-donut-chart-card-wrapper">
  <div class="chart-card-header">{{header}}</div>
  <div class="statistics-donut-chart-row">
    <div class="col flex-grow-0">
      <div
        kendo-chart
        k-options="chartOptions"
        class="dashboard-chart"
      ></div>
    </div>
    <div class="col">
      <div ng-if="totallocations > 0" class="locations-legend-list" ng-class="{'longer': locations.length > 5}">
        <div class="legend-item" ng-repeat="item in locations">
          <span class="legend-marker" ng-style="{ background: item.color }"></span>
          <span ng-if="item.category">{{ item.category }} - {{item.value}}</span>
        </div>
      </div>
      <div ng-if="totallocations === 0" class="no-locations-message">
        <span>{{noeventstext}}</span>
      </div>
    </div>
  </div>
</div>
`,
            link: function (scope, element) {
                scope.chartOptions = {
                    title: { visible: false },
                    legend: { visible: false },
                    seriesDefaults: { type: "donut", holeSize: 30 },
                    series: [
                        {
                            data:
                                scope.locations && scope.locations.length > 0
                                    ? scope.locations
                                    : [
                                          {
                                              category: "",
                                              value: 1,
                                              color: "#5c6670",
                                          },
                                      ],
                            field: "value",
                            categoryField: "category",
                            padding: 2,
                        },
                    ],
                    tooltip: {
                        visible: scope.totallocations > 0,
                        template: "#= category #: #= value #",
                    },
                    chartArea: { width: 110, height: 110 },
                    seriesClick: function (e) {
                        if (!e.dataItem.elements || !e.dataItem.elements.length)
                            return;
                        var deviceIdsParam = e.dataItem.elements.join(",");
                        scope.$apply(function () {
                            $location
                                .path("/main/sensor-overview")
                                .search({ deviceId: deviceIdsParam });
                        });
                    },
                    render: function () {
                        var $chart = $(element).find(".k-chart");
                        $chart.find(".donut-hole-text").remove();
                        $('<div class="donut-hole-text"></div>')
                            .text(scope.totallocations)
                            .css({
                                position: "absolute",
                                left: "50%",
                                top: "50%",
                                transform: "translate(-50%, -50%)",
                                "font-weight": "bold",
                                "pointer-events": "none",
                            })
                            .appendTo($chart);
                    },
                };
            },
        };
    },
]);
